/**
 * What one credit buys. These mirror the server's PRAY_CREDIT exchange rates (`CurrencyExchangeRates`), which every
 * charge and cost confirmation uses, so change them together.
 *
 * Translations are charged once for each target language. Social clips are charged by the length of the episode's
 * video, however many clips it produces.
 */
export const CREDIT_RATES = {
  videoTranslationSeconds: 20,
  audioTranslationMinutes: 30,
  socialClipsVideoMinutes: 5,
  audiobookWords: 60,
  emails: 500,
} as const;
